import {
  EHeadingStyleVariant,
  ELinkButtonVariant,
  Grid,
  GridItem,
  Heading,
  LinkButton,
} from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import OwnerStory from '@/assets/become-a-host/rv/owner-story.png';
import RVPhotographyTips from '@/assets/become-a-host/rv/rv-photography-tips.png';

import styles from './BecomeAHost.module.css';

export const HostingBlogs = () => {
  const intl = useIntl();

  const contentData = [
    {
      title: intl.formatMessage({
        defaultMessage: 'Learn how to impress with photos',
        id: 'Cu/eTu',
      }),
      link: 'https://www.outdoorsy.com/blog/how-to-amazing-photography-tips-for-an-even-better-listing',
      linkLabel: intl.formatMessage({ defaultMessage: 'RV photography 101', id: 'kXekTp' }),
      image: RVPhotographyTips,
    },

    {
      title: intl.formatMessage({
        defaultMessage: 'We love our hosts — meet some of them',
        id: 'COAMFs',
      }),
      link: 'https://www.outdoorsy.com/blog/category/owner-stories/page/1',
      linkLabel: intl.formatMessage({ defaultMessage: 'Explore owner stories', id: 'dSen+/' }),
      image: OwnerStory,
    },
  ];

  return (
    <section className={styles.spacing}>
      <Heading variant={EHeadingStyleVariant.H3} className="text-center">
        <FormattedMessage defaultMessage="The Art" id="40bsv0" />
      </Heading>
      <Heading variant={EHeadingStyleVariant.H3Alt} className="mb-12 text-center">
        <FormattedMessage defaultMessage="of Hosting" id="BE2zGS" />
      </Heading>
      <Grid spacing={6} className="m-0">
        {contentData.map(({ title, link, linkLabel, image }) => (
          <GridItem sm={6} xs={12} key={title}>
            <div className="relative w-full h-80">
              <Image
                alt={title}
                src={image}
                objectFit="cover"
                className="rounded-2xl"
                layout="fill"
              />
            </div>
            <Heading variant={EHeadingStyleVariant.H6} className="mt-6 mb-4">
              {title}
            </Heading>

            <LinkButton
              href={link}
              label={linkLabel}
              variant={ELinkButtonVariant.UnderlineWithIcon}
              target="_blank"
            />
          </GridItem>
        ))}
      </Grid>
    </section>
  );
};
